import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import SubsystemLayout from '../layouts/SubsystemLayout.vue'
import Dispatch from '../views/Dispatch.vue'
import Drivers from '../views/Drivers.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'
import Routes from '../views/Routes.vue'
import Trips from '../views/Trips.vue'
import Vehicles from '../views/Vehicles.vue'

const ui = (name: 'Forbidden' | 'NotFound' | 'NetworkError' | 'AppUnavailable') => () =>
  import('@yc/ui-kit').then((m) => m[name])

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { public: true, blank: true },
  },
  {
    path: '/',
    component: SubsystemLayout,
    children: [
      { path: '', name: 'home', component: Home, meta: { perm: 'dsp:home' } },
      // 个人中心：顶栏「个人中心」下拉项就是 go('/profile')，早期各子系统都漏了这条路由，
      // 点进去落到 /:pathMatch(.*)* 显示「页面不存在」。
      // 不挂 meta.perm：这是登录用户自己的信息页，挂权限码会把没配菜单权限的普通用户弹到 403。
      { path: 'profile', name: 'profile', component: Profile },
      { path: 'dispatch', name: 'dispatch', component: Dispatch, meta: { perm: 'dsp:task' } },
      { path: 'trips', name: 'trips', component: Trips, meta: { perm: 'dsp:trip' } },
      { path: 'vehicles', name: 'vehicles', component: Vehicles, meta: { perm: 'dsp:vehicle' } },
      { path: 'drivers', name: 'drivers', component: Drivers, meta: { perm: 'dsp:driver' } },
      { path: 'routes', name: 'routes', component: Routes, meta: { perm: 'dsp:route' } },
      { path: '403', name: 'forbidden', component: ui('Forbidden') },
    ],
  },
  {
    // 放在鉴权布局之外：企业被停用（40303）时 /me 本身就会失败，若仍走布局，
    // 外壳会继续发注定失败的请求，且守卫每次都判定"未登录"从而在登录页与本页之间死循环。
    path: '/app-unavailable',
    name: 'app-unavailable',
    component: ui('AppUnavailable'),
    meta: { public: true, blank: true },
    props: (route) => ({
      code: Number(route.query.code ?? 40301),
      msg: String(route.query.msg ?? ''),
    }),
  },
  {
    path: '/network-error',
    name: 'network-error',
    component: ui('NetworkError'),
    meta: { public: true, blank: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: ui('NotFound'),
    meta: { public: true, blank: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
